import type { FullscreenOpenOtherTabProps } from '@/shared/types/notifications';

export const getPrimaryButtonLinkParams = (restProps: FullscreenOpenOtherTabProps) => {
    const primaryButtonHref = restProps.openOtherTab ? restProps.primaryButtonHref : undefined;
    const primaryButtonTarget = restProps.openOtherTab ? '_blank' : undefined;
    const primaryButtonRel = restProps.openOtherTab ? 'noopener noreferrer' : undefined;

    return {
        primaryButtonHref,
        primaryButtonTarget,
        primaryButtonRel,
    };
};
